const DEFAULT_PATIENT_LOCALE = 'english';

const defaultLanguageToLocaleKey: Record<string, string> = {
  en: 'english',
  'en-us': 'english',
  'en-gb': 'english',
  english: 'english',
  ko: 'korean',
  kr: 'korean',
  korean: 'korean',
  ja: 'japanese',
  japanese: 'japanese',
};

export function mapDefaultLanguageToLocaleKey(language?: string | null): string {
  const normalized = `${language || ''}`.trim().toLowerCase();
  return defaultLanguageToLocaleKey[normalized] || DEFAULT_PATIENT_LOCALE;
}

